module.exports = __webpack_public_path__ + "img/Default-profile.09932d15.png";